import {
    ClientConfigurationBackend,
    ClientConfigurationEntry,
    ClientConfigurationForm,
    SelectedEntry
} from '../Types/Types'
import { DEFAULT_CME_ID } from '../../../../../../React/Common/Constants/ServerValues'
import { ALL_VALUE, ANY_DEVICE_VALUE } from '../../../../../../React/Common/Constants/DefaultValues'
import { EMPTY_STRING } from '../../../../../../NonReact/constants/Common'

export const mapFromServer = (
    data: ClientConfigurationBackend,
    { telsysID, partitionID, deviceID }: SelectedEntry
): ClientConfigurationForm => ({
    details: {
        id: data.ID ?? EMPTY_STRING,
        description: data.Description
    },
    scope: {
        cmeID: data.CmeID ?? DEFAULT_CME_ID,
        telsysID: telsysID ?? ALL_VALUE,
        partitionID: partitionID ?? ALL_VALUE,
        deviceID: deviceID ?? ANY_DEVICE_VALUE,
        filterRecursively: true
    },
    policy: {
        item: EMPTY_STRING,
        value: false,
        policies: Object.entries(data?.Policies ?? {})?.map(
            ([key, value]: [
                string,
                string | number | boolean | string[] | Record<string, string>
            ]): ClientConfigurationEntry => ({
                item: key,
                default: value,
                value
            })
        )
    },
    settings: {
        item: EMPTY_STRING,
        value: false,
        settings: Object.entries(data?.Settings ?? {})?.map(
            ([key, value]: [
                string,
                string | number | boolean | string[] | Record<string, string>
            ]): ClientConfigurationEntry => ({
                item: key,
                default: value,
                value
            })
        )
    }
})
